import { useTranslation } from 'react-i18next';
import type { SupportedLanguage } from '../../i18n';
import { SUPPORTED_LANGUAGES } from '../../i18n';

interface LanguageOption {
  value: SupportedLanguage;
  label: string;
  flag: string;
}

const languages: LanguageOption[] = [
  { value: 'ca', label: 'Català', flag: 'CAT' },
  { value: 'es', label: 'Español', flag: '🇪🇸' },
  { value: 'en', label: 'English', flag: '🇬🇧' },
];

export function LanguageSelector() {
  const { i18n, t } = useTranslation('translation');

  const currentLanguage = (SUPPORTED_LANGUAGES.includes(i18n.language as SupportedLanguage)
    ? i18n.language
    : 'es') as SupportedLanguage;

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="language-select" className="text-sm font-medium text-gray-700 dark:text-gray-300">
        {t('common.language')}
      </label>
      <select
        id="language-select"
        value={currentLanguage}
        onChange={(e) => i18n.changeLanguage(e.target.value as SupportedLanguage)}
        className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
      >
        {languages.map((lang) => (
          <option key={lang.value} value={lang.value}>
            {lang.flag} {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
}
